import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from 'vindi-ds-components';
import { ProductContext } from '../../contexts/product_context';
import CardModal from './cardModal';
import { background } from './styles';

const DiscardModal = ({
  title, subtitle, confirm, cancel,
}) => {
  const { setOpenDiscardModal, openDiscardModal } = useContext(ProductContext);
  const navigate = useNavigate();

  const handleDiscart = () => {
    navigate('/admin/products');
    setOpenDiscardModal(false);
  };

  if (openDiscardModal) {
    return (
      <Box css={background}>
        <CardModal
          handleDiscart={handleDiscart}
          setOpenDiscardModal={setOpenDiscardModal}
          titleDiscardModal={title}
          subtitleDiscardModal={subtitle}
          confirmDiscard={confirm}
          cancelDiscard={cancel}
        />
      </Box>
    );
  }
  return null;
};

export default DiscardModal;
